import api from 'api/api'
import { toast } from "react-toastify"

export const GET_ESTABLISHMENT = "[ESTABLISHMENT] GET ESTABLISHMENT"
export const CRUD_ESTABLISHMENT = "[ESTABLISHMENT] CRUD ESTABLISHMENT"

export const GET_BRANCHES = "[BRANCHES] GET BRANCHES"
export const CRUD_BRANCH = "[BRANCHES] CRUD BRANCH"

export const GET_OPTIONS_BY_BRANCH = "[OPTIONS] GET OPTIONS BY BRANCH"
export const CRUD_BRANCH_OPTION = "[OPTIONS] CRUD OPTIONS BRANCH"

export const INITIALIZE_BRANCH_PRICES = "[PRICES] INITIALIZE BRANCH PRICES"

export const GET_BANK_ACCOUNTS = "[BANK ACCOUNTS] GET BANK ACCOUNTS"
export const SAVE_BANK_ACCOUNT = "[BANK ACCOUNTS] SAVE BANK ACCOUNT"
export const DELETE_BANK_ACCOUNT = "[BANK ACCOUNTS] DELETE BANK ACCOUNT"

export function getEstablishment() {
  const request = api.get(`/establecimiento/datos`)
  return (dispatch) => {
    dispatch({ type: GET_ESTABLISHMENT, payload: { loading: true } })
    request.then((response) => {
      dispatch({ type: GET_ESTABLISHMENT, payload: { loading: false, data: response.data.detalles } })
      setTimeout(() => {
        dispatch({ type: GET_ESTABLISHMENT, payload: { loading: false, data: null } })
      }, 50)
    }).catch((error) => {
      dispatch({ type: GET_ESTABLISHMENT, payload: { loading: false, data: null } })
      toast.error("No se pudo obtener los datos del establecimiento")
      console.log(error)
    })
  }
}

export function saveEstablishment(form) {
  const request = api.post(`/establecimiento/guardar`, form)
  return (dispatch) => {
    dispatch({ type: CRUD_ESTABLISHMENT, payload: { loading: true } })
    request.then((response) => {
      if (parseInt(response.data.status) === 400) {
        dispatch({ type: CRUD_ESTABLISHMENT, payload: { loading: false, crud: false } })
        toast.error(response.data.message)
        return
      }
      dispatch({ type: CRUD_ESTABLISHMENT, payload: { loading: false, crud: true } })
      toast.success(response.data.message)

      setTimeout(() => {
        dispatch({ type: CRUD_ESTABLISHMENT, payload: { loading: false, crud: false } })
      }, 50)
    }).catch((error) => {
      dispatch({ type: CRUD_ESTABLISHMENT, payload: { loading: false, crud: false } })
      console.log(error)
    })
  }
}

export function getBranches() {
  const request = api.get(`/sucursal/registros`)
  return (dispatch) => {
    dispatch({ type: GET_BRANCHES, payload: { loading: true } })
    request.then((response) => {
      dispatch({ type: GET_BRANCHES, payload: { loading: false, data: response.data.detalles } })
    })
  }
}

export function saveBranch(form) {
  const request = api.post(`/sucursal/guardar`, form)
  return (dispatch) => {
    dispatch({ type: CRUD_BRANCH, payload: { loading: true } })
    request.then((response) => {
      if (parseInt(response.data.status) === 400) {
        dispatch({ type: CRUD_BRANCH, payload: { loading: false, crud: false } })
        toast.error(response.data.message)
        return
      }

      dispatch({ type: CRUD_BRANCH, payload: { loading: false, crud: true } })
      toast.success(response.data.message)

      setTimeout(() => {
        dispatch({ type: CRUD_BRANCH, payload: { loading: false, crud: false } })
      }, 50)
    }).catch((error) => {
      dispatch({ type: CRUD_BRANCH, payload: { loading: false, crud: false } })
      console.log(error)
    })
  }
}

export function deleteBranch(form) {
  const request = api.post(`/sucursal/eliminar`, form)
  return (dispatch) => {
    dispatch({ type: CRUD_BRANCH, payload: { loading: true } })
    request.then((response) => {
      if (parseInt(response.data.status) === 400) {
        dispatch({ type: CRUD_BRANCH, payload: { loading: false, crud: false } })
        toast.error(response.data.message)
        return
      }

      dispatch({ type: CRUD_BRANCH, payload: { loading: false, crud: true } })
      toast.success(response.data.message)

      setTimeout(() => {
        dispatch({ type: CRUD_BRANCH, payload: { loading: false, crud: false } })
      }, 50)
    }).catch((error) => {
      dispatch({ type: CRUD_BRANCH, payload: { loading: false, crud: false } })
      console.log(error)
    })
  }
}

export function initializeBranchPrices(form) {
  const request = api.post(`/product-unit-measures/initialize-prices`, form)
  return (dispatch) => {
    dispatch({ type: INITIALIZE_BRANCH_PRICES, payload: { loading: true } })
    request.then((response) => {
      if (parseInt(response.data.status) === 400) {
        dispatch({ type: INITIALIZE_BRANCH_PRICES, payload: { loading: false, copied: null } })
        toast.error(response.data.message)
        return
      }
      dispatch({ type: INITIALIZE_BRANCH_PRICES, payload: { loading: false, copied: response.data.data } })
      toast.success(response.data.message)
      setTimeout(() => {
        dispatch({ type: INITIALIZE_BRANCH_PRICES, payload: { loading: false, copied: null } })
      }, 50)
    }).catch((error) => {
      dispatch({ type: INITIALIZE_BRANCH_PRICES, payload: { loading: false, copied: null } })
      toast.error("No se pudo inicializar los precios de la sucursal")
      console.log(error)
    })
  }
}

export function getOptionsByBranch(branchId = 0) {
  const request = api.get(`/opciones/obtener-por-sucursal/${branchId}`)
  return (dispatch) => {
    dispatch({ type: GET_OPTIONS_BY_BRANCH, payload: { loading: true } })
    request.then((response) => {
      dispatch({ type: GET_OPTIONS_BY_BRANCH, payload: { loading: false, data: response.data.detalles } })
    }).catch((error) => {
      dispatch({ type: GET_OPTIONS_BY_BRANCH, payload: { loading: false, data: null } })
      toast.error("No se pudo obtener las opciones de la sucursal")
      console.log(error)
    })
  }
}

export function saveOptionIgvType(form) {
  const request = api.post(`/opciones/guardar-tipo-igv`, form)
  return (dispatch) => {
    dispatch({ type: CRUD_BRANCH_OPTION, payload: { loading: true } })
    request.then((response) => {
      if (parseInt(response.data.status) === 400) {
        dispatch({ type: CRUD_BRANCH_OPTION, payload: { loading: false, crud: false } })
        toast.error(response.data.message)
        return
      }

      dispatch({ type: CRUD_BRANCH_OPTION, payload: { loading: false, crud: true } })
      toast.success(response.data.message)

      setTimeout(() => {
        dispatch({ type: CRUD_BRANCH_OPTION, payload: { loading: false, crud: false } })
      }, 50)
      return
    }).catch((error) => {
      dispatch({ type: CRUD_BRANCH_OPTION, payload: { loading: false, crud: false } })
      console.log(error)
    })
  }
}

export function saveFreeOperations(form) {
  const request = api.post(`/opciones/guardar-op-gratuitas`, form)
  return (dispatch) => {
    dispatch({ type: CRUD_BRANCH_OPTION, payload: { loading: true } })
    request.then((response) => {
      if (parseInt(response.data.status) === 400) {
        dispatch({ type: CRUD_BRANCH_OPTION, payload: { loading: false, crud: false } })
        toast.error(response.data.message)
        return
      }

      dispatch({ type: CRUD_BRANCH_OPTION, payload: { loading: false, crud: true } })
      toast.success(response.data.message)

      setTimeout(() => {
        dispatch({ type: CRUD_BRANCH_OPTION, payload: { loading: false, crud: false } })
      }, 50)
      return
    }).catch((error) => {
      dispatch({ type: CRUD_BRANCH_OPTION, payload: { loading: false, crud: false } })
      console.log(error)
    })
  }
}

export function saveVoucherFormat(form) {
  const request = api.post(`/opciones/guardar-formato-comprobante`, form)
  return (dispatch) => {
    dispatch({ type: CRUD_BRANCH_OPTION, payload: { loading: true } })
    request.then((response) => {
      if (parseInt(response.data.status) === 400) {
        dispatch({ type: CRUD_BRANCH_OPTION, payload: { loading: false, crud: false } })
        toast.error(response.data.message)
        return
      }

      dispatch({ type: CRUD_BRANCH_OPTION, payload: { loading: false, crud: true } })
      toast.success(response.data.message)

      setTimeout(() => {
        dispatch({ type: CRUD_BRANCH_OPTION, payload: { loading: false, crud: false } })
      }, 50)
      return
    }).catch((error) => {
      dispatch({ type: CRUD_BRANCH_OPTION, payload: { loading: false, crud: false } })
      console.log(error)
    })
  }
}

export function saveComisionVenta(form) {
  const request = api.post(`/opciones/guardar-comision-venta`, form)
  return (dispatch) => {
    dispatch({ type: CRUD_BRANCH_OPTION, payload: { loading: true } })
    request.then((response) => {
      if (parseInt(response.data.status) === 400) {
        dispatch({ type: CRUD_BRANCH_OPTION, payload: { loading: false, crud: false } })
        toast.error(response.data.message)
        return
      }
      dispatch({ type: CRUD_BRANCH_OPTION, payload: { loading: false, crud: true } })
      toast.success(response.data.message)
      setTimeout(() => {
        dispatch({ type: CRUD_BRANCH_OPTION, payload: { loading: false, crud: false } })
      }, 50)
      return
    }).catch((error) => {
      dispatch({ type: CRUD_BRANCH_OPTION, payload: { loading: false, crud: false } })
      console.log(error)
    })
  }
}

export function savePermitirDetraccion(form) {
  const request = api.post(`/opciones/guardar-permitir-detraccion`, form)
  return (dispatch) => {
    dispatch({ type: CRUD_BRANCH_OPTION, payload: { loading: true } })
    request.then((response) => {
      if (parseInt(response.data.status) === 400) {
        dispatch({ type: CRUD_BRANCH_OPTION, payload: { loading: false, crud: false } })
        toast.error(response.data.message)
        return
      }
      dispatch({ type: CRUD_BRANCH_OPTION, payload: { loading: false, crud: true } })
      toast.success(response.data.message)
      setTimeout(() => {
        dispatch({ type: CRUD_BRANCH_OPTION, payload: { loading: false, crud: false } })
      }, 50)
      return
    }).catch((error) => {
      dispatch({ type: CRUD_BRANCH_OPTION, payload: { loading: false, crud: false } })
      console.log(error)
    })
  }
}

export function savePermitirPrecios(form) {
  const request = api.post(`/opciones/guardar-permitir-precios`, form)
  return (dispatch) => {
    dispatch({ type: CRUD_BRANCH_OPTION, payload: { loading: true } })
    request.then((response) => {
      if (parseInt(response.data.status) === 400) {
        dispatch({ type: CRUD_BRANCH_OPTION, payload: { loading: false, crud: false } })
        toast.error(response.data.message)
        return
      }
      dispatch({ type: CRUD_BRANCH_OPTION, payload: { loading: false, crud: true } })
      toast.success(response.data.message)
      setTimeout(() => {
        dispatch({ type: CRUD_BRANCH_OPTION, payload: { loading: false, crud: false } })
      }, 50)
      return
    }).catch((error) => {
      dispatch({ type: CRUD_BRANCH_OPTION, payload: { loading: false, crud: false } })
      console.log(error)
    })
  }
}

export function saveDetraccionCuentaBancaria(form) {
  const request = api.post(`/opciones/guardar-cuenta-detraccion`, form)
  return (dispatch) => {
    dispatch({ type: CRUD_BRANCH_OPTION, payload: { loading: true } })
    request.then((response) => {
      if (parseInt(response.data.status) === 400) {
        dispatch({ type: CRUD_BRANCH_OPTION, payload: { loading: false, crud: false } })
        toast.error(response.data.message)
        return
      }
      dispatch({ type: CRUD_BRANCH_OPTION, payload: { loading: false, crud: true } })
      toast.success(response.data.message)
      setTimeout(() => {
        dispatch({ type: CRUD_BRANCH_OPTION, payload: { loading: false, crud: false } })
      }, 50)
      return
    }).catch((error) => {
      dispatch({ type: CRUD_BRANCH_OPTION, payload: { loading: false, crud: false } })
      console.log(error)
    })
  }
}

export function saveOptionLogo(form) {
  const request = api.post(`/opciones/guardar-logo`, form)
  return (dispatch) => {
    dispatch({ type: CRUD_BRANCH_OPTION, payload: { loading: true } })
    request.then((response) => {
      if (parseInt(response.data.status) === 400) {
        dispatch({ type: CRUD_BRANCH_OPTION, payload: { loading: false, crud: false } })
        toast.error(response.data.message)
        return
      }
      dispatch({ type: CRUD_BRANCH_OPTION, payload: { loading: false, crud: true } })
      toast.success(response.data.message)
      setTimeout(() => {
        dispatch({ type: CRUD_BRANCH_OPTION, payload: { loading: false, crud: false } })
      }, 50)
      return
    }).catch((error) => {
      dispatch({ type: CRUD_BRANCH_OPTION, payload: { loading: false, crud: false } })
      console.log(error)
    })
  }
}

export function getBankAccountsAction() {
  const req = api.get(`/bank-accounts`)
  return (dispatch) => {
    dispatch({ type: GET_BANK_ACCOUNTS, payload: { loading: true } })
    req.then(({ data }) => {
      dispatch({ type: GET_BANK_ACCOUNTS, payload: { data: data.data } })
    }).catch((error) => {
      dispatch({ type: GET_BANK_ACCOUNTS, payload: { data: [] } })
      console.log(error)
    }).finally(() => {
      dispatch({ type: GET_BANK_ACCOUNTS, payload: { loading: false } })
    })
  }
}

export function saveBankAccountAction(data) {
  const req = api.post('/bank-accounts', data)
  return (dispatch) => {
    dispatch({ type: SAVE_BANK_ACCOUNT, payload: { saving: true } })
    req.then(({ data }) => {
      if (Number(data.status) !== 200) {
        toast.error(data.message)
        return
      }
      dispatch({ type: SAVE_BANK_ACCOUNT, payload: { saved: true, data: data.data } })
    }).catch((error) => {
      console.log(SAVE_BANK_ACCOUNT, error)
    }).finally(() => {
      dispatch({ type: SAVE_BANK_ACCOUNT, payload: { saving: false, saved: false } })
    })
  }
}

export function deleteBankAccountAction(bankAccountId) {
  const req = api.delete(`/bank-accounts/${bankAccountId}`)
  return (dispatch) => {
    dispatch({ type: DELETE_BANK_ACCOUNT, payload: { deleting_id: bankAccountId } })
    req.then(({ data }) => {
      if (Number(data.status) !== 200) {
        toast.error(data.message)
        return
      }
      dispatch({ type: DELETE_BANK_ACCOUNT, payload: { deleted_id: bankAccountId } })
    }).catch((error) => {
      console.log(DELETE_BANK_ACCOUNT, error)
    }).finally(() => {
      dispatch({ type: DELETE_BANK_ACCOUNT, payload: { deleting_id: bankAccountId } })
    })
  }
}